import React, { useState, useEffect, useCallback } from "react";
import "./apidocsform.css";
import { LabelInput, LabelTextarea } from "../../Inputs";
import BlueButton from "../../BlueButton";
import { toast } from "sonner";
import axios from "axios";

const labelStyle = { color: "#615382", fontSize: ".75rem" };
const inputStyle = { borderColor: "#E6D4FF" };

const inputFields = [
  {
    name: "user_name",
    type: "text",
    label: "Your name",
    placeholder: "John Doe",
    pattern: "[A-Za-z ]*",
  },
  {
    name: "user_org",
    type: "text",
    label: "Your company",
    placeholder: "ABC Industries",
    pattern: "[A-Za-z]*",
  },
  {
    name: "user_business_email",
    type: "email",
    label: "Business email",
    placeholder: "john@company.com",
  },
  {
    name: "mobile",
    type: "tel",
    label: "Your mobile",
    placeholder: "9800000021",
    maxLength: 10,
  },
];

const APIDocsForm = ({ isOpen, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [userDetails, setUserDetails] = useState({
    user_name: "",
    user_org: "",
    user_business_email: "",
    enquiry_text: "",
    mobile: "",
    docs_Click: "True",
  });

  const isValidEmail = useCallback((email) => {
    return /^[a-zA-Z0-9._%+-]+@(?!gmail\.com|yahoo\.com|hotmail\.com|yahoo\.co\.in|aol\.com|live\.com|outlook\.com)[a-zA-Z0-9_-]+\.[a-zA-Z]{2,61}$/i.test(
      email
    );
  }, []);

  const isValidMobile = useCallback(
    (mobile) => /^[6-9]\d{9}$/.test(mobile),
    []
  );

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setUserDetails((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
      user_name,
      user_org,
      user_business_email,
      enquiry_text,
      mobile,
    } = userDetails;

    if (!isValidMobile(mobile)) {
      toast.error("Please enter a valid mobile number");
      return;
    }
    if (!user_name.trim()) {
      toast.error("Please enter your name");
      return;
    }
    if (!user_org.trim()) {
      toast.error("Please enter your company name");
      return;
    }
    if (!isValidEmail(user_business_email)) {
      toast.error("Please enter a valid business email address");
      return;
    }
    if (!enquiry_text.trim()) {
      toast.error("Please enter a valid enquiry");
      return;
    }

    setLoading(true);

    try {
      const url = process.env.REACT_APP_BASE_URL;
      const headers = { "Content-Type": "application/json" };
      await axios.post(url, userDetails, { headers });

      toast.success(
        "Thank you for showing interest in the Explore API documentation."
      );
      setUserDetails({
        user_name: "",
        user_org: "",
        user_business_email: "",
        enquiry_text: "",
        mobile: "",
      });

      if (!sessionStorage.getItem("user_registered")) {
        sessionStorage.setItem("user_registered", "true");
      }

      setTimeout(() => handleredirection("apidocs"), 2000);
      onClose();
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleredirection = useCallback((key) => {
    const urls = {
      apidocs: "https://api.befisc.com",
      newsletter:
        "https://takh7ucwgg0.typeform.com/to/kG2iZbDL?typeform-source=www.linkedin.com",
    };
    window.open(urls[key], "_blank", "noopener,noreferrer");
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => (document.body.style.overflow = "auto");
  }, [isOpen]);

  useEffect(() => {
    if (sessionStorage.getItem("user_registered") === "true" && isOpen) {
      handleredirection("apidocs");
      onClose();
    }
  }, [isOpen, handleredirection, onClose]);

  if (!isOpen) return null;

  return (
    <div className="api-modal-overlay">
      <div className="modal-form">
        {/* Close Button */}
        <button onClick={onClose} className="modal-close-button">
          &times;
        </button>

        {/* Modal Content */}
        <div className="modal-heading">
          <span>Access API Docs</span>
          <span>
            Unlock our API documentation and explore the potential to integrate
            our solutions into your applications.
          </span>
        </div>

        <form onSubmit={handleSubmit} className="modal-form-inner">
          {inputFields.map(
            ({ name, type, label, placeholder, maxLength, pattern }) => (
              <LabelInput
                pattern={pattern}
                key={name}
                labelStyle={labelStyle}
                inputStyle={inputStyle}
                name={name}
                type={type}
                label={label}
                placeholder={placeholder}
                value={userDetails[name]}
                onChange={handleChange}
                maxLength={maxLength}
                required
              />
            )
          )}

          {/* Textarea Input */}
          <LabelTextarea
            labelStyle={labelStyle}
            textareaStyle={inputStyle}
            placeholder="Enter additional details"
            name="enquiry_text"
            label="Enter your request details"
            value={userDetails.enquiry_text}
            onChange={handleChange}
          />

          {/* Submit Button */}
          <div className="modal-submit-btn">
            <BlueButton
              text={loading ? "Redirecting..." : "Get access now"}
              styles={{ pointerEvents: loading ? "none" : "auto" }}
              type="submit"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default React.memo(APIDocsForm);
